import { styled } from 'styled-components';

import { Media } from '@/js/libs/ui';
import { Tooltip } from '@/js/libs/ui/src/V2';

// #region index
export const StyledTooltip = styled(Tooltip)`
  flex-direction: column;
`;

export const RootWrapper = styled.div`
  z-index: 1011;

  @media ${Media.xsMax} {
    margin-left: -16px;
    padding-top: 10px;
    background-color: ${({ theme }) => theme.colors.grey00_1};
  }

  @media ${Media.smMin} {
    padding-left: 12px;
    margin-top: -60px;
  }

  @media ${Media.lgMin} {
    margin-top: -68px;
  }
`;
// #endregion

// #region SearchList
export const WrapperContent = styled.div`
  width: 100vw;
  overflow: auto;
  background-color: ${({ theme }) => theme.colors.grey00_6};

  @media ${Media.xsMax} {
    border-top: 1px solid ${({ theme }) => theme.colors.grey10_1};
    height: calc(100vh - 171px);
    background-color: ${({ theme }) => theme.colors.grey00_1};
  }

  @media ${Media.smMin} {
    border-radius: ${({ theme }) => theme.borders.radiusMedium}px;
    ${({ theme }) => theme.shadows.large};
    width: 504px;
    max-height: calc(100vh - 80px);
  }

  @media ${Media.mdMin} {
    width: 560px;
  }

  @media ${Media.lgMin} {
    max-height: calc(100vh - 64px);
  }
`;
// #endregion

// #region SearchListBlock
export const BlockWrapper = styled.div`
  padding: 24px 0 20px 0;
  display: flex;
  flex-direction: column;
  border-top: 1px solid ${({ theme }) => theme.colors.grey10_1};
  &:first-child {
    border-top: none;
  }
`;

export const BlockTitleWrapper = styled.div`
  padding: 0 24px;
  margin-bottom: 8px;
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const UnavailableWrapper = styled.div`
  padding: 0 24px;
`;

export const ShowMoreWrapper = styled.div`
  margin-top: 8px;
  padding: 0 24px;

  a {
    color: ${({ theme }) => theme.colors.link100};
    text-decoration: none;
    cursor: pointer;

    &:hover {
      color: ${({ theme }) => theme.colors.link120};
    }
  }
`;
// #endregion

// #region SearchListItem
export const ItemWrapper = styled.div<{ $highlightColor: string }>`
  padding: 0 8px;

  span,
  mark {
    ${({ theme }) => theme.typography.textMedium}
  }

  mark {
    font-weight: 500;
    border-radius: 2px;
    padding: 2px 1px;
    margin: 0 -1px;
    background-color: ${({ $highlightColor }) => $highlightColor};
    color: ${({ theme }) => theme.colors.black_1};
  }
`;

export const HoverWrapper = styled.div`
  padding: 4px 16px;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey05_1};
    border-radius: ${({ theme }) => theme.borders.radiusMedium}px;
  }
`;
// #endregion
